// import { Box, Typography, Grid, styled, Divider } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import { useLocation, useSearchParams } from 'react-router-dom';
// import Footer from './Footer';
// import Navbar from './Navbar';
// import axios from 'axios';

// import axiosInsatnace from "../asiosConfig";

// const StyledImage = styled('img')(({ theme }) => ({
//   width: '75%',
//   height: '60%',
//   borderRadius: '8px',
//   boxShadow: '0px 4px 4px 4px #00000040',
//  fontFamily: "'Montserrat', sans-serif",
// }));

// const StoryText = styled(Typography)(({ theme }) => ({
//   marginTop: theme.spacing(2),
//   lineHeight: 1.8,
//    fontFamily: "'Montserrat', sans-serif",
// }));

// export const SuccessStoryDetail = () => {
//   const location = useLocation();
//   const [searchParams] = useSearchParams();

//   // 1️⃣ STORY FROM STATE (if available)
//   const storyFromState = location.state || null;

//   // 2️⃣ STORY ID FROM URL
//   const id = searchParams.get("id");

//   const [story, setStory] = useState(storyFromState);

// const formatMarriageDate = (dateString) => {
//   if (!dateString) return "Date not available";

//   const date = new Date(dateString);

//   if (isNaN(date.getTime())) {
//     return "Date not available";
//   }

//   return date.toLocaleDateString('en-GB', {
//     day: 'numeric',
//     month: 'long',
//     year: 'numeric',
//   });
// };

//   useEffect(() => {
//   if (storyFromState) return;

//   if (!id) {
//     console.error("❌ No ID detected in URL");
//     return;
//   }

//   const fetchStory = async () => {
//     try {
//       // const res = await axios.get("https://console.indmatrimony.in/api/v2/stories");

//      const res = await axiosInsatnace.get("stories");

//       console.log("📌 FULL STORY LIST:", res.data.data);
//       console.log("📌 Looking for story with auto_id =", id);

//       const foundStory = res.data.data.find(
//         (item) => String(item.auto_id) === String(id)
//       );

//       console.log("📌 Found story:", foundStory);

//       // setStory(foundStory);
//       if (foundStory) {
//   setStory(foundStory);
// } else {
//   console.error("❌ Story not found for id:", id);
// }

//     } catch (err) {
//       console.error("Failed to load story:", err);
//     }
//   };

//   fetchStory();
// }, [id, storyFromState]);

//   if (!story) return <p>Loading...</p>;

//   const { images, bride, groom, story: storyText, marriage_date } = story;

//   return (
//     <Box>
//       <Navbar />
//       <Box mt={20} mb={5} px={2} sx={{
//     fontFamily: '"Montserrat", sans-serif',   // ← this does it
//   }}>
//         <Grid container spacing={4} alignItems="center" justifyContent="center">
//           <Grid item xs={12} md={10}>
//             <Typography variant="h4" align="center" fontWeight="bold" gutterBottom fontFamily={"'Montserrat', sans-serif"}>
//               {bride} & {groom} - A Perfect Match!
//             </Typography>

//             <Typography
//               variant="subtitle1"
//               align="center"
//               color="text.secondary"
//               gutterBottom
//               fontFamily={"'Montserrat', sans-serif"}
//             >
//               {/* {new Date(marriage_date).toLocaleDateString('en-GB', {
//                 day: 'numeric',
//                 month: 'long',
//                 year: 'numeric',
//               })} */}

//               {formatMarriageDate(marriage_date)}

//             </Typography>
//           </Grid>

//           <Grid item xs={12} md={5}>
//             <StyledImage src={images} alt={`${bride} weds ${groom}`} />
//           </Grid>

//           <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: "black" }} />

//           <Grid item xs={12} md={5} textAlign={'left'}>
//             <Typography variant="h6" fontWeight="bold" gutterBottom>
//               Read how {bride} and {groom} found each other on IND Matrimony
//             </Typography>
//             <StoryText variant="body1">{storyText}</StoryText>
//           </Grid>
//         </Grid>
//       </Box>
//       <Footer />
//     </Box>
//   );
// };

import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import axiosInsatnace from "../asiosConfig";

import nameLeftDesign from "../images/nameLeftDesign.png";
import nameRightDesign from "../images/nameRightDesign.png";
import rangoliIcon from "../images/rangoliIcon.svg";

import successStarIcon from "../images/sucessStarIcon.png";

import journeyBtn from "../images/startJourneybutton.png";

import matchedIcon from "../images/storyCalenderIcon.png";
import marriedIcon from "../images/storyMarriedIcon.png";

export const SuccessStoryDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const storyFromState = location.state || null;
  const id = searchParams.get("id");

  const [story, setStory] = useState(storyFromState);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  useEffect(() => {
    if (storyFromState) return;
    if (!id) return;

    const fetchStory = async () => {
      try {
        const res = await axiosInsatnace.get("stories");
        const found = res.data.data.find(
          (item) => String(item.auto_id) === String(id),
        );
        if (found) setStory(found);
      } catch (err) {
        console.error("Failed to fetch story:", err);
      }
    };

    fetchStory();
  }, [id, storyFromState]);

  if (!story) return null;

  const {
    images,
    bride,
    groom,
    story: storyText,
    marriage_date,
    engagement_date,
  } = story;

  return (
    <Box sx={{ backgroundColor: "#f3f5f7" }}>
      <Navbar />

      <Box
        sx={{
          maxWidth: "900px",
          margin: "0 auto",
          paddingTop: "100px",
          paddingBottom: "80px",
          textAlign: "center",
          fontFamily: "Montserrat, sans-serif",
        }}
      >
        {/* Success Badge */}
        {/* Success Story Pill */}
        <Box
          sx={{
            width: "183px",
            height: "38px",
            margin: "0 auto 30px auto",
            position: "relative",
            borderRadius: "100px",
            backgroundColor: "rgba(255,255,255,0.1)",
            border: "1px solid rgba(255,119,5,0.88)",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "3px",
              left: "4px",
              width: "173px",
              height: "30px",
              borderRadius: "100px",
              background:
                "linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0.2)), linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              color: "#fff",
              fontFamily: "Montserrat",
              fontSize: "13px",
              fontWeight: 600,
            }}
          >
            <img
              src={successStarIcon}
              alt="star"
              style={{ width: "18px", height: "18px" }}
            />
            Success Story
          </Box>
        </Box>

        {/* Heading */}
        <Typography
          sx={{
            fontFamily: "Playfair Display, serif",
            fontSize: { xs: "28px", md: "40px" },
            fontWeight: 600,
            marginBottom: "20px",
          }}
        >
          Welcome to <span style={{ color: "#e53935" }}>Ind Matrimony</span>
        </Typography>

        {/* Name with side designs */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "30px",
          }}
        >
          <img
            src={nameLeftDesign}
            alt="left design"
            height="10"
            width="auto"
          />

          <Typography
            sx={{
              fontWeight: 600,
              color: "#e53935",
              fontSize: "16px",
            }}
          >
            {bride} & {groom}
          </Typography>

          <img
            src={nameRightDesign}
            alt="right design"
            height="10"
            width="auto"
          />
        </Box>

        {/* Main Image */}
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <img
            src={images}
            alt={`${bride} & ${groom}`}
            style={{
              width: "100%",
              maxWidth: "420px",
              borderRadius: "20px",
              boxShadow: "0px 6px 20px rgba(0,0,0,0.15)",
            }}
          />
        </Box> */}

        {/* Image Frame */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            margin: "10px 10px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#ffffff",
              padding: "14px",
              borderRadius: "24px",
              boxShadow: "0px 4px 25px rgba(0,0,0,0.25)",
            }}
          >
            <img
              src={images}
              alt={`${bride} & ${groom}`}
              style={{
                width: "100%",
                maxWidth: "420px",
                borderRadius: "16px",
                display: "block",
              }}
            />
          </Box>
        </Box>

        {/* Rangoli */}
        <Box sx={{ marginBottom: "30px" }}>
          <img src={rangoliIcon} alt="rangoli" height="40" />
        </Box>

        {/* Story Card */}
        <Box
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            padding: { xs: "20px", md: "35px" },
            boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
            margin: "15px 10px",
          }}
        >
          <Typography
            sx={{
              fontStyle: "italic",
              color: "#d32f2f",
              lineHeight: 1.8,
              marginBottom: "30px",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            "{storyText}"
          </Typography>

          {/* Matched/Married */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: { xs: "40px", md: "120px" },
              flexWrap: "wrap",
              marginTop: "15px",
            }}
          >
            {/* Matched */}
            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "25px",
                minWidth: "220px",
              }}
            >
             
              <Box
                sx={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  boxShadow: "0px 4px 13px rgba(0, 0, 0, 0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <img
                  src={matchedIcon}
                  alt="matched"
                  style={{ width: "26px", height: "26px" }}
                />
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#4f4f4f",
                    fontFamily: "Montserrat",
                  }}
                >
                  Matched
                </Typography>

                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "#000",
                    fontFamily: "Montserrat",
                  }}
                >
                  {formatDate(engagement_date)}
                </Typography>
              </Box>
            </Box> */}

            {/* Married */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "25px",
                minWidth: "220px",
                textAlign: "left",
              }}
            >
              {/* Circle */}
              <Box
                sx={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  boxShadow: "0px 4px 13px rgba(0, 0, 0, 0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <img
                  src={marriedIcon}
                  alt="married"
                  style={{ width: "28px", height: "28px" }}
                />
              </Box>

              {/* Text */}
              <Box>
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#4f4f4f",
                    fontFamily: "Montserrat",
                  }}
                >
                  Married
                </Typography>

                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "#000",
                    fontFamily: "Montserrat",
                  }}
                >
                  {formatDate(marriage_date)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Bottom Rangoli */}
        <Box sx={{ margin: "0px 0 25px 0" }}>
          <img src={rangoliIcon} alt="rangoli" height="40" />
        </Box>

        {/* CTA Button */}
        {/* <Box>
          <Box
            onClick={() => navigate("/otpLogin?mode=register")}
            sx={{
              display: "inline-block",
              background: "linear-gradient(90deg, #b71c1c, #d32f2f)",
              color: "#fff",
              padding: "12px 40px",
              borderRadius: "40px",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "15px",
              transition: "0.3s",
              "&:hover": {
                opacity: 0.9,
              },
            }}
          >
            Start Your Journey
          </Box>
        </Box> */}

        {/* CTA Button */}
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Box
            onClick={() => navigate("/otpLogin?mode=register")}
            sx={{
              position: "relative",
              display: "inline-block",
              width: {
                xs: "260px",
                sm: "320px",
                md: "405px",
                lg: "450px",
              },
              cursor: "pointer",
              overflow: "hidden", // IMPORTANT for clipping shine
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "translateY(-3px)",
              },

              "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-75%",
                width: "50%",
                height: "100%",
                background:
                  "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
                transform: "skewX(-25deg)",
                transition: "left 0.7s ease",
                pointerEvents: "none",
              },

              "&:hover::after": {
                left: "125%",
              },
            }}
          >
            {/* Button Image */}
            <Box
              component="img"
              src={journeyBtn}
              alt="Start Your Journey"
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />

            {/* Overlay Text */}
            <Typography
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontFamily: "Montserrat",
                fontWeight: 600,
                fontSize: {
                  xs: "14px",
                  sm: "16px",
                  md: "18px",
                  lg: "20px",
                },
                color: "#ffffff",
                pointerEvents: "none",
                whiteSpace: "nowrap",
              }}
            >
              Start Your Journey
            </Typography>
          </Box>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};
